import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { AppContext } from './AppContext';
import axios from 'axios';

export const ShareModal: React.FC<{ isOpen: boolean, onClose: () => void }> = ({ isOpen, onClose }) => {
    const { encodedPath } = useContext(AppContext);
    
    const [url, setUrl] = useState<string>();
    const handleShortenUrl = async (url: string) => {
        setUrl(undefined);
        try{
            const {data} = await axios.post('/rtn-api/shortener.json', {
                url
            });

            if(data && data.data && data.data.link){
                setUrl(data.data.link)
            }else{
                setUrl(url);
            }
        }catch(e){
            setUrl(url);
        }
    }
    useEffect(() => {
        if(isOpen){
            handleShortenUrl(encodedPath);
        }
    }, [isOpen, encodedPath]);

    let [copyCtaText, setCopyCtaText] = useState("Copy link")

    useEffect(() => {
        setCopyCtaText('Copy link');
    }, [isOpen])

    const inputRef = useRef<HTMLInputElement>(null);
    const copyToClipboard = () => {
        if(!inputRef.current) return;
        inputRef.current.select();
        document.execCommand('copy');
        setCopyCtaText('Link copied');
    }
    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-10 overflow-y-auto bg-opacity-40 transition-all bg-black"
                    onClose={onClose}
                >
                    <div className="min-h-screen px-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className="relative inline-block w-full max-w-md p-6 md:p-8 my-8 overflow-hidden align-middle transition-all transform bg-offwhite shadow paragraph text-center">
																<button
																	type="button"
																	className="inline-block absolute top-2 right-3 text-2xl"
																	onClick={onClose}
																>
																		<i className="fal fa-times"></i>
																</button>
																<Dialog.Title
                                    as="h3"
                                    className="heading-3"
                                >
                                    Save or share tour
                                </Dialog.Title>
                                <div className="mt-3 paragraph">
                                    <p className="mb-4">
                                        Copy the link below to share your tour, or save it and continue editing later.
                                    </p>
                                    <input defaultValue={url === '' ? 'Loading...' : url} ref={inputRef} disabled={url === ''} readOnly className="p-1 border border-black w-full text-lg font-dmsans font-medium" />
                                </div>

                                <div className="mt-5">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center px-4 py-2 text-offwhite bg-black border border-transparent button button-text"
                                        onClick={() => copyToClipboard()}
                                    >
                                        {copyCtaText} <svg width="17px" className="fill-offwhite inline-block ml-2" viewBox="0 0 16 14.12"><path d="M0,9H4v5.15H16v-9H12V0H0ZM1.34,7.69V2.56h9.3V5.15H4V7.69Zm4,5.12V7.71h9.32v5.1Z"/></svg>
                                    </button>
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}